const FF = "'Google Sans', Inter, 'Segoe UI', Roboto, Arial, sans-serif";

// One smooth lap in the first ~60% of the cycle, then a short pause — a pass every ~2.8s.
const EASE = '0.42 0 0.58 1;0 0 1 1';

function animDisabled() {
	try {
		return /(?:^|;\s*)siLogoAnim=off(?:;|$)/.test(document.cookie);
	} catch (e) {
		return false;
	}
}

const template = `
	<span class="logo-wrap">
		<svg :width="width" :height="height" viewBox="0 0 152 41" fill="none" xmlns="http://www.w3.org/2000/svg" class="site-logo">
			<!-- animated frame (hidden in plain mode, e.g. on the landing page) -->
			<g v-if="!plain">
				<!-- static hairline frame -->
				<rect x="2" y="2" width="148" height="37" rx="10" fill="none" stroke="#e8edf3" stroke-width="1.1"/>
				<!-- travelling blue light -->
				<rect x="2" y="2" width="148" height="37" rx="10" fill="none" stroke="#0288D1" stroke-width="1.4" stroke-linecap="round" pathLength="100" stroke-dasharray="16 84" :style="{display: animOff ? 'none' : ''}">
					<animate attributeName="stroke-dashoffset" values="0;-100;-100" keyTimes="0;0.6;1" calcMode="spline" keySplines="${EASE}" dur="2.8s" repeatCount="indefinite"/>
				</rect>
				<!-- travelling yellow light (opposite side) -->
				<rect x="2" y="2" width="148" height="37" rx="10" fill="none" stroke="#FFC107" stroke-width="1.4" stroke-linecap="round" pathLength="100" stroke-dasharray="16 84" :style="{display: animOff ? 'none' : ''}">
					<animate attributeName="stroke-dashoffset" values="-50;-150;-150" keyTimes="0;0.6;1" calcMode="spline" keySplines="${EASE}" dur="2.8s" repeatCount="indefinite"/>
				</rect>
			</g>
			<g transform="translate(7,11)">
				<text x="0" y="24" font-family="${FF}" font-size="30" font-weight="700" letter-spacing="-1.2" fill="#3F4F68">stat</text>
				<!-- rebuilt dotless 'i' body of 'inside' -->
				<rect x="60" y="8" width="4.4" height="16" rx="2" fill="#3F4F68"/>
				<!-- stacked bar-chart dot over the 'i' -->
				<g transform="translate(59.2,4)">
					<rect x="0" y="-2"   width="6" height="2.2" rx="1" fill="#FFC107"/>
					<rect x="0" y="-5.4" width="6" height="2.4" rx="1" fill="#0288D1"/>
					<rect x="0" y="-9"   width="6" height="2.6" rx="1" fill="#0288D1"/>
				</g>
				<text x="66" y="24" font-family="${FF}" font-size="30" font-weight="700" letter-spacing="-1.2" fill="#3F4F68">nsıde</text>
			</g>
		</svg>
		<button
			v-if="!plain"
			type="button"
			class="logo-anim-btn"
			@click.stop.prevent="toggleAnim"
			:title="animOff ? 'Turn logo animation on' : 'Pause logo animation'"
			:aria-label="animOff ? 'Play logo animation' : 'Pause logo animation'"
		>
			<svg v-if="!animOff" width="11" height="11" viewBox="0 0 12 12" aria-hidden="true">
				<rect x="2" y="1.5" width="2.8" height="9" rx="1" fill="currentColor"/>
				<rect x="7.2" y="1.5" width="2.8" height="9" rx="1" fill="currentColor"/>
			</svg>
			<svg v-else width="11" height="11" viewBox="0 0 12 12" aria-hidden="true">
				<path d="M3 1.8 L10 6 L3 10.2 Z" fill="currentColor"/>
			</svg>
		</button>
	</span>
`;

export default {
	template,
	props: {
		width: null,
		height: null,
		plain: { type: Boolean, default: false }
	},
	data() {
		return {
			animOff: animDisabled()
		};
	},
	methods: {
		toggleAnim() {
			this.animOff = !this.animOff;
			try {
				document.cookie = 'siLogoAnim=' + (this.animOff ? 'off' : 'on') +
					'; path=/; max-age=' + (60 * 60 * 24 * 365);
			} catch (e) {}
		}
	}
};
